/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGiveaways } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import PageLanding from "../../components/PageLanding";

const ByTimeOfDayLanding = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const giveaways = useSelector(getGiveaways);
  const timeOfDayBoxes = [
    {
      id: "weekendDay",
      title: "Weekend Day Games",
      boxName: "Weekend<br />Day Games",
      img: "time-of-day/weekend-games.png",
    },
    {
      id: "weekendEve",
      title: "Weekend Evening Games",
      boxName: "Weekend<br />Evening Games",
      img: "time-of-day/weekend-evening-games.png",
    },
    {
      id: "weekdayDay",
      title: "weekday Day Games",
      boxName: "weekday<br />Day Games",
      img: "time-of-day/weekday-day-games.png",
    },
    {
      id: "weekdayEve",
      title: "weekday Evening Games",
      boxName: "weekday<br />Evening Games",
      img: "time-of-day/weekday-evening-games.png",
    },
  ];

  useEffect(() => {
    if (!type) history.push("/");
  }, [giveaways, history, type]);
  //

  return (
    <div>
      <FormTitle title="Select time of day" />
      <PageLanding
        boxesArr={timeOfDayBoxes}
        goToPage={"by-time-of-day"}
        trackingTitle="Select time of day"
      />
      <FormController
        backTo="/ticket-single-group"
        startOver="/"
        showBack
        showStartOver
        
      />
    </div>
  );
};

export default ByTimeOfDayLanding;
